export default __webpack_public_path__ + "static/media/Minuta.772e9ba0.svg";